import {
  BULK_MINIMUM_QUANTITY,
  groupByDesign,
  useProjectItems,
} from '@customink/project-service-react-components';

export const useHasAnySinglesQuantities = () => {
  const { data: projectItems } = useProjectItems();

  if (!projectItems || projectItems.length === 0) return false;

  const designGroups = groupByDesign(projectItems);

  const anyGroupsBelowBulkMin = Object.values(designGroups).some((group) => {
    const groupTotalQuantity = group.reduce((groupCount, item) => {
      const itemQuantity = (item?.sizesQuantities || []).reduce(
        (itemCount, sizeQuantity) => itemCount + (sizeQuantity?.quantity || 0),
        0,
      );
      return groupCount + itemQuantity;
    }, 0);
    return groupTotalQuantity < BULK_MINIMUM_QUANTITY;
  });

  return anyGroupsBelowBulkMin;
};
